export interface ICommercialInfoSchema {
    clientName: string;
    clientCode: string;
    address: string;
    coordinates: {
        latitude: string;
        longitude: string;
    };
    isStopover?: boolean;
    isPlanned?: boolean;
}
